/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RetrieveProductRequest = {
  /**
   * The unique identifier of the product.
   */
  productId: string;
};

/** @internal */
export const RetrieveProductRequest$inboundSchema: z.ZodType<
  RetrieveProductRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  product_id: z.string(),
}).transform((v) => {
  return remap$(v, {
    "product_id": "productId",
  });
});
/** @internal */
export type RetrieveProductRequest$Outbound = {
  product_id: string;
};

/** @internal */
export const RetrieveProductRequest$outboundSchema: z.ZodType<
  RetrieveProductRequest$Outbound,
  z.ZodTypeDef,
  RetrieveProductRequest
> = z.object({
  productId: z.string(),
}).transform((v) => {
  return remap$(v, {
    productId: "product_id",
  });
});

export function retrieveProductRequestToJSON(
  retrieveProductRequest: RetrieveProductRequest,
): string {
  return JSON.stringify(
    RetrieveProductRequest$outboundSchema.parse(retrieveProductRequest),
  );
}
export function retrieveProductRequestFromJSON(
  jsonString: string,
): SafeParseResult<RetrieveProductRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RetrieveProductRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RetrieveProductRequest' from JSON`,
  );
}
